/**
 * Dashboard Filter Context
 * Provides global filter state for all dashboard widgets
 */

import React, { createContext, useContext, useState, useCallback, ReactNode } from "react";
import { DashboardFilterContext as FilterContextType } from "../types";

interface DashboardFilterContextValue {
  filters: FilterContextType;
  updateFilters: (updates: Partial<FilterContextType>) => void;
  resetFilters: () => void;
}

const DashboardFilterContext = createContext<DashboardFilterContextValue | undefined>(undefined);

const defaultFilters: FilterContextType = {
  selectedAgentIds: [],
};

interface DashboardFilterProviderProps {
  children: ReactNode;
  initialFilters?: Partial<FilterContextType>;
}

export const DashboardFilterProvider: React.FC<DashboardFilterProviderProps> = ({
  children,
  initialFilters,
}) => {
  const [filters, setFilters] = useState<FilterContextType>({
    ...defaultFilters,
    ...initialFilters,
  });

  const updateFilters = useCallback((updates: Partial<FilterContextType>) => {
    setFilters((prev) => ({
      ...prev,
      ...updates,
    }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, []);

  return (
    <DashboardFilterContext.Provider
      value={{
        filters,
        updateFilters,
        resetFilters,
      }}
    >
      {children}
    </DashboardFilterContext.Provider>
  );
};

export const useDashboardFilters = () => {
  const context = useContext(DashboardFilterContext);
  if (!context) {
    throw new Error("useDashboardFilters must be used within DashboardFilterProvider");
  }
  return context;
};



















